import { Component } from '@angular/core';

@Component({
  selector: 'kt-app-profile',
  imports: [],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

}
